import React, {useEffect, useState} from "react";
import {Spin} from 'antd';
import Comment from "./Comment";
import SharedService from "../../services/shared/service";
import {formatToTimestamp} from "../../utils/datetime.utils";
import {hasAny} from "../../utils/array.utils";

const CommentList = ({documentId, user, disableStatus}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [comments, setComments] = useState([]);

    useEffect(() => {
        fetchComments();
    }, []);

    const fetchComments = () => {
        setIsLoading(true);

        SharedService.get({
            token: user.token,
            url: `notes/${documentId}`,
        })
            .then(response => {
                setIsLoading(false);
                if (response?.length > 0) {
                    setComments(response.map((comment) => ({
                        id: comment.id,
                        author: comment?.createdBy,
                        content: comment?.note,
                        datetime: formatToTimestamp(comment?.createdOn, "dd MMM yyyy HH:mm"),
                    })));
                } else {
                    setComments([]);
                }
            })
            .catch(errorInfo => {
                console.error("Get Comments List Error:", errorInfo);
                setIsLoading(false);
            });
    };

    return (
        <div>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: 8,
                    paddingBottom: 8,
                    borderBottom: '1px solid #F1F3F7',
                }}
            >
                <span
                    style={{
                        fontSize: 12,
                        fontWeight: 600,
                        color: '#7A849A',
                        textTransform: 'uppercase',
                        letterSpacing: '.4px',
                    }}
                >
                    {comments.length} {comments.length === 1 ? 'comment' : 'comments'}
                </span>
            </div>

            {isLoading ? (
                <div style={{textAlign: 'center', padding: '24px 0'}}>
                    <Spin/>
                </div>
            ) : hasAny(comments) ? (
                <div>
                    {comments.map(item => <Comment key={item.id} {...item}/>)}
                </div>
            ) : (
                <div
                    style={{
                        padding: '32px 0',
                        textAlign: 'center',
                        color: '#7A849A',
                        fontSize: 13,
                        fontStyle: 'italic',
                    }}
                >
                    No comments yet.
                </div>
            )}
        </div>
    );
};

export default CommentList;
